export default __webpack_public_path__ + "static/media/logo.2e279fb8.png";